import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Card from '../common/Card';
import Button from '../common/Button';
import Loading from '../common/Loading';

// ← IMPORTS MODALS - VÉRIFIER QUE CES FICHIERS EXISTENT
import CreateSimpleModal from './CreateSimpleModal';
import EditSimpleModal from './EditSimpleModal';
import AssignAssociationToSimpleModal from './AssignAssociationToSimpleModal';

const AllSimplesList = () => {
  const [simples, setSimples] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedSimple, setSelectedSimple] = useState(null);

  useEffect(() => {
    fetchSimples();
  }, []);

  const fetchSimples = async () => {
    try {
      const response = await api.get('/simples/all');
      console.log('✅ Simples loaded:', response.data.data);
      setSimples(response.data.data);
    } catch (error) {
      console.error('❌ Erreur chargement Simples:', error);
      alert('Erreur lors du chargement des Simples');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    console.log('🗑️ Delete clicked for ID:', id);
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce Simple ?')) return;

    try {
      await api.delete(`/admins/simples/${id}`);
      alert('Simple supprimé avec succès');
      fetchSimples();
    } catch (error) {
      console.error('❌ Erreur suppression:', error);
      alert(error.response?.data?.message || 'Erreur lors de la suppression');
    }
  };

const handleEdit = (simple) => {
  console.log('✏️ Edit clicked for:', simple);
  // ← FERMER LES AUTRES MODALS D'ABORD
  setShowCreateModal(false);
  setShowAssignModal(false);
  // Puis ouvrir celui-ci
  setSelectedSimple(simple);
  setShowEditModal(true);
};

const handleAssign = (simple) => {
  console.log('🔗 Assign clicked for:', simple);
  // ← FERMER LES AUTRES MODALS D'ABORD
  setShowCreateModal(false);
  setShowEditModal(false);
  // Puis ouvrir celui-ci
  setSelectedSimple(simple);
  setShowAssignModal(true);
};

const handleCreate = () => {
  console.log('➕ Create clicked');
  // ← FERMER LES AUTRES MODALS D'ABORD
  setShowEditModal(false);
  setShowAssignModal(false);
  setSelectedSimple(null);
  // Puis ouvrir celui-ci
  setShowCreateModal(true);
};

  console.log('🔄 Render - showCreateModal:', showCreateModal);
  console.log('🔄 Render - showEditModal:', showEditModal);
  console.log('🔄 Render - showAssignModal:', showAssignModal);

  if (loading) return <Loading />;

  return (
    <div className="p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6 sm:mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
          Tous les User Simples
        </h1>
        <Button 
          onClick={() => {
            console.log('🖱️ Button "Nouveau Simple" clicked!');
            handleCreate();
          }}
        >
          ➕ Nouveau Simple
        </Button>
      </div>

      {simples.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-lg shadow overflow-hidden">
            <thead className="bg-gradient-blue text-white">
              <tr>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">Nom</th>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">Email</th>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold hidden md:table-cell">Owner</th>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold hidden lg:table-cell">Association</th>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">Statut</th>
                <th className="px-4 sm:px-6 py-3 text-left text-xs sm:text-sm font-semibold">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {simples.map((simple) => (
                <tr key={simple._id} className="hover:bg-gray-50">
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm">{simple.name}</td>
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm">{simple.email}</td>
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm hidden md:table-cell">
                    {simple.ownerId?.name || 'N/A'}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm hidden lg:table-cell">
                    {simple.associationId ? (
                      <span className="px-2 py-1 bg-green-100 text-green-800 text-xs rounded-full">
                        {simple.associationId.name}
                      </span>
                    ) : (
                      <span className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full">
                        Aucune
                      </span>
                    )}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm">
                    {simple.active ? (
                      <span className="px-2 py-1 bg-green-500 text-white text-xs rounded-full">Actif</span>
                    ) : (
                      <span className="px-2 py-1 bg-red-500 text-white text-xs rounded-full">Inactif</span>
                    )}
                  </td>
                  <td className="px-4 sm:px-6 py-4 text-xs sm:text-sm">
                    <div className="flex flex-wrap gap-2">
                      <button
                        onClick={() => {
                          console.log('🖱️ Button Edit clicked!');
                          handleEdit(simple);
                        }}
                        className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition text-xs sm:text-sm"
                        title="Modifier"
                      >
                        ✏️
                      </button>
                      <button
                        onClick={() => {
                          console.log('🖱️ Button Assign clicked!');
                          handleAssign(simple);
                        }}
                        className="px-3 py-1 bg-purple-500 text-white rounded hover:bg-purple-600 transition text-xs sm:text-sm"
                        title="Assigner Association"
                      >
                        🔗
                      </button>
                      <button
                        onClick={() => {
                          console.log('🖱️ Button Delete clicked!');
                          handleDelete(simple._id);
                        }}
                        className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600 transition text-xs sm:text-sm"
                        title="Supprimer"
                      >
                        🗑️
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <Card>
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg mb-4">Aucun User Simple trouvé</p>
            <Button onClick={handleCreate}>Créer un Simple</Button>
          </div>
        </Card>
      )}

      {/* Modal Création */}
      {showCreateModal && (
        <>
          {console.log('🎭 Rendering CreateSimpleModal')}
          <CreateSimpleModal
            onClose={() => {
              console.log('❌ Closing create modal');
              setShowCreateModal(false);
            }}
            onSuccess={() => {
              console.log('✅ Create success');
              setShowCreateModal(false);
              fetchSimples();
            }}
          />
        </>
      )}

      {/* Modal Modification */}
      {showEditModal && selectedSimple && (
        <>
          {console.log('🎭 Rendering EditSimpleModal for:', selectedSimple)}
          <EditSimpleModal
            simple={selectedSimple}
            onClose={() => {
              console.log('❌ Closing edit modal');
              setShowEditModal(false);
              setSelectedSimple(null);
            }}
            onSuccess={() => {
              console.log('✅ Edit success');
              setShowEditModal(false);
              setSelectedSimple(null);
              fetchSimples();
            }}
          />
        </>
      )}

      {/* Modal Assignation */}
      {showAssignModal && selectedSimple && (
        <>
          {console.log('🎭 Rendering AssignAssociationToSimpleModal for:', selectedSimple)}
          <AssignAssociationToSimpleModal
            simple={selectedSimple}
            onClose={() => {
              console.log('❌ Closing assign modal');
              setShowAssignModal(false);
              setSelectedSimple(null);
            }}
            onSuccess={() => {
              console.log('✅ Assign success');
              setShowAssignModal(false);
              setSelectedSimple(null);
              fetchSimples();
            }}
          />
        </>
      )}
    </div>
  );
};

export default AllSimplesList;